import navigation from "@/lang/en/navigation";
import generics from "@/lang/en/generics";
import questions from "@/lang/en/questions";
import a11y from "@/lang/en/a11y";
import velt from "@/lang/en/velt";

export default {
  ...navigation,
  ...generics,
  ...questions,
  ...a11y,
  ...velt
}
